<template>
  <div class="relative flex flex-col section-template w-screen h-90vh z-20 justify-center pointer-events-none">
    <div class="flex flex-col justify-center items-center w-2/3 flex-1 text-center text-blue-900 px-3 pt-32 mx-auto">
      <section-sound-icon />
      <button
        @click="handleAudioChange"
        class="flex bg-black rounded-full text-white px-4 py-2 font-bold border border-black border-t-2 border-b-2 border-r-2 border-l-2 mt-6 cursor-pointer pointer-events-auto button-style"
      >
        {{ $store.state.soundOn ? $t(`sections.${content.id}.soundOff`) : $t(`sections.${content.id}.soundOn`) }}
      </button>
    </div>
    <section-scroll-button
      class="anim-item scroll-button-component relative -mt-8 pointer-events-auto"
      @click.native="$emit('next-section')"
    />
  </div>
</template>

<script>
import SectionSoundIcon from "./SectionSoundIcon";
import SectionScrollButton from "./SectionScrollButton";
import { gsap } from "gsap";

export default {
  name: "SectionSound",
  components: {
    SectionSoundIcon,
    SectionScrollButton,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    nextSection: {
      type: String,
      required: false,
    },
  },

  mounted() {
    gsap.from(`#${this.content.id}`, {
      opacity: "0",
      duration: "2",
      ease: "power3.inOut",
      delay: 1,
    });
  },

  methods: {
    handleAudioChange() {
      var audio = document.getElementById("audio-player");
      if (this.$store.state.soundOn) {
        audio.pause();
      } else {
        audio.play();
      }

      this.$store.commit("handleAudioChange", !this.$store.state.soundOn);
    },
  },
};
</script>

<style lang="postcss" scoped>
p a {
  @apply underline;
}

.h-90vh {
  height: 90vh;
}

@media screen and (max-height: 599px) {
  h2 {
    @apply text-xl mb-4;
  }
  p {
    @apply leading-tight text-tiny;
  }
  .scroll-button-component {
    @apply hidden;
  }
}

@media screen and (min-height: 600px) and (max-height: 812px) and (max-width: 420px) {
  .scroll-button-component {
    display: flex;
    bottom: 3vh;
  }
}
</style>